import { render, staticRenderFns } from "./ProgressBarECG.vue?vue&type=template&id=3daf9341&scoped=true&"
import script from "./ProgressBarECG.vue?vue&type=script&lang=js&"
export * from "./ProgressBarECG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3daf9341",
  null
  
)

export default component.exports